import { render, staticRenderFns } from "./favoriteCell.vue?vue&type=template&id=15c04a3a"
import script from "./favoriteCell.vue?vue&type=script&lang=js"
export * from "./favoriteCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports